module.exports = __webpack_public_path__ + "img/IMG-20191012-WA0009.3c59afdc.jpg";